import QueryString from 'rlink-querystring';
import { targetEnum } from 'rlink-router/constants';

export default function externalNavTo ({url, params = null, targetType = targetEnum.self}) {
  return () => {
    if (params) {
      url += `?${new QueryString(params).toString()}`;
    }
    if (targetType === targetEnum.new) {
      window.open(url);
    } else {
      window.location.href = url;
    }
  };
}



// WEBPACK FOOTER //
// ./lib/rlink-router/actions/externalNavTo.js